module.exports = __webpack_public_path__ + "static/media/zalopay.b559c53e.png";